module.exports = {
	"leftNav": {
		"label": "CRUD échantillon"
	},
	"crudModule": {
		"actionButtons": {
			"createGateway": "Créer passerelle",
			"editGateway": "Modifier la passerelle",
			"deleteGateway": "Supprimer passerelle"
		},
		"gatewayGrid": {
			"name": "prénom",
			"vdcName": "Org VDC",
			"gatewayIP": "IP de la passerelle",
			"configuration": "Configuration",
			"ha": "High Availability",
			"externalNetworks": "External Networks",
			"status": "Status",
			"renderers": {
				"failureText": "Échoué",
				"failureToolTip": "création de passerelle échoué",
				"creationText": "Créé",
				"creationToolTip": "création de passerelle réussi",
				"inProgressText": "En cours",
				"inProgressToolTip": "création de passerelle est en cours"
			}
		},
		"gatewayPopup": {
			"createMode": {
				"title": "Créer passerelle",
				"saveButtonLabel": "Ajouter"
			},
			"editMode": {
				"title": "Modifier la passerelle",
				"saveButtonLabel": "sauvegarder"
			},
			"formElementLabels": {
				"name": "Name",
				"namePlaceHolder": "Gateway Name",
				"description": "Description",
				"vdc": "Select VDC",
				"selectVdc": "Select Organization VDC",
				"externalNetwork": "Select External Network",
				"selectExternalNetwork": "Select External Network",
				"ipCount": "IP Count"
			},
			"errorMessages": {
				"emptyName": "Please provide the gateway name",
				"emptyVdc": "Please select VDC",
				"emptyNetwork": "Please select network",
				"emptyIP": "Please provide the number of IP required",
				"minIP": "Please provide at least 1 IP",
				"maxIP": "No Of IPs are more than available IP"
			}
		}
	},
	"drModule": {
		"title": "Disaster Recovery",
		"overviewTab": {
			"title": "Overview",
			"placeholder": "OVERVIEW TAB CONTENT TODO"
		},
		"replicationsTab": {
			"title": "Individual Replications",
			"placeholder": "REPLICATIONS TAB CONTENT TODO"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/app/fr.json
// module id = 372T
// module chunks = 0